import Icon from "./icon.vue";
import {useIconfont} from "./useIconftont";
Icon.use = useIconfont;
useIconfont("https://st-gdx.dancf.com/gaodingx/4244/configs/system/20210316-110816-becc.js");
export default Icon;
export * from "./useIconftont";
